import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import "./CustomerTickets.css";
import "./DashboardCus.css";

const CustomerTickets = () => {
  const { id: company_id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const { start, end, company_name } = location.state || {};

  const [tickets, setTickets] = useState([]);
  const [totalStar, setTotalStar] = useState(0);

  const safeStart = start ? new Date(start) : null;
  const safeEnd = end ? new Date(end) : null;

  const startStr = safeStart
    ? `${safeStart.getMonth() + 1}-${safeStart.getFullYear()}`
    : "";
  const endStr = safeEnd
    ? `${safeEnd.getMonth() + 1}-${safeEnd.getFullYear()}`
    : "";

  useEffect(() => {
    const loadTickets = async () => {
      try {
        const res = await axios.get(
          `/dashboardcus/customertickets?company_id=${company_id}&start=${startStr}&end=${endStr}`,
          { withCredentials: true },
        );

        setTickets(res.data.tickets || []);
        setTotalStar(res.data.avg_total_star || 0);
      } catch (err) {
        if (err.response?.status === 401) {
          setTickets([]);
          setTotalStar(0);
        }
      }
    };

    if (startStr && endStr) {
      loadTickets();
    }
  }, [company_id, startStr, endStr]);

  const renderStars = (value) => {
    if (typeof value !== "number") return "-";

    const stars = [];
    const full = Math.floor(value);
    const half = value % 1 >= 0.5;
    const empty = 5 - full - (half ? 1 : 0);

    for (let i = 0; i < full; i++) stars.push("⭐");
    if (half) stars.push("⯪");
    for (let i = 0; i < empty; i++) stars.push("☆");

    return stars.join(" ");
  };

  const formatResponseTime = (minutes) => {
    if (minutes == null) return "ยังไม่มีการตอบกลับ";

    if (minutes < 1) return "น้อยกว่า 1 นาที";

    const days = Math.floor(minutes / (60 * 24));
    const hours = Math.floor((minutes % (60 * 24)) / 60);
    const mins = minutes % 60;

    let text = [];

    if (days > 0) text.push(`${days} วัน`);
    if (hours > 0) text.push(`${hours} ชั่วโมง`);
    if (mins > 0) text.push(`${mins} นาที`);

    return text.join(" ");
  };

  return (
      <div className="ct-report-page">
        <div className="ct-report-header">
          <button className="back-btn" onClick={() => navigate(-1)}>
            Back
          </button>

          <h2>{company_name || "Company"} – Tickets</h2>
        </div>

        <div className="ct-report-star-box">
          <h3>
            Average Star (ช่วงเวลาที่เลือก): {Number(totalStar || 0).toFixed(2)}
          </h3>
          <div className="ct-report-star-icons">{renderStars(totalStar)}</div>
        </div>

        <div className="ct-report-table-box">
          <table className="ct-report-table">
            <thead>
              <tr>
                <th>Ticket</th>
                <th>Customer</th>
                <th>Issue Summary</th>
                <th>Severity</th>
                <th>SLA</th>
                <th>First Response</th>
                <th>Response SLA</th>
                <th>Avg Star</th>
                <th>
                  Resolution Time
                  <br />
                  <span className="ct-report-subtext">
                    (เวลาตั้งแต่เปิดเคสจนถึงปิดเคส)
                  </span>
                </th>
              </tr>
            </thead>

            <tbody>
              {tickets.map((t) => (
                <tr key={t.id}>
                  <td
                    className="ct-report-ticket-link"
                    onClick={() => {
                      navigate(`/admin/ticketadmin/${t.id}`, {
                        state: { ticket: t },
                      });
                    }}
                  >
                    {t.id}
                  </td>

                  <td>{t.customer_name}</td>
                  <td>{t.issue_summary}</td>
                  <td>{t.severity_level}</td>
                  <td>{t.sla}</td>
                  <td>{formatResponseTime(t.first_response_minutes)}</td>

                  <td
                    className={
                      t.response_sla_ok === true
                        ? "ct-report-sla-ok"
                        : t.response_sla_ok === false
                          ? "ct-report-sla-bad"
                          : ""
                    }
                  >
                    {t.response_sla_ok === null
                      ? "-"
                      : t.response_sla_ok
                        ? "Resolved on Time"
                        : "Resolved Late"}
                  </td>

                  <td>
                    {typeof t.avg_star === "number" ? (
                      <>
                        {t.avg_star.toFixed(2)}
                        <div className="ct-report-star-icons">
                          {renderStars(t.avg_star)}
                        </div>
                      </>
                    ) : (
                      "-"
                    )}
                  </td>

                  <td>{t.close_duration}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
  );
};

export default CustomerTickets;
